import { render, staticRenderFns } from "./floodHazardReview.component.vue?vue&type=template&id=72c95eb8&scoped=true&"
import script from "./floodHazardReview.component.vue?vue&type=script&lang=js&"
export * from "./floodHazardReview.component.vue?vue&type=script&lang=js&"
import style0 from "./floodHazardReview.component.vue?vue&type=style&index=0&id=72c95eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c95eb8",
  null
  
)

export default component.exports